import api from '@anm/api';
import { UploadMediaFile } from '@anm/api/modules/uploads';
import { useEffect } from 'react';

export type CheckerProps = {
  onReady: (upload: UploadMediaFile) => void;
  checkReady?(upload: UploadMediaFile): void;
  onUploadStart?(): void;
  onUploadError?(): void;
  uploadId?: string;
};

const isUploadStable = (uploadEntity: UploadMediaFile) => uploadEntity.upload.status === 'stable';

const DELAY = 1000;

let timer: number;

const useUploadChecker = ({ onReady, checkReady, onUploadStart, onUploadError, uploadId }: CheckerProps) => {
  useEffect(() => {
    if (!uploadId) return;

    const checkUploadStatus = async () => {
      try {
        const uploadEntity = await api().uploads.getUploadMedia({ id: uploadId, isCached: false });
        const isStable = isUploadStable(uploadEntity);

        const isReady = checkReady ? isStable && checkReady(uploadEntity) : isStable;

        if (isReady) {
          onReady(uploadEntity);
        } else {
          if (onUploadStart) onUploadStart();

          timer = window.setTimeout(checkUploadStatus, DELAY);
        }
      } catch {
        onUploadError && onUploadError();
      }
    };

    checkUploadStatus();

    return () => clearTimeout(timer);
  }, [uploadId]);
};

export default useUploadChecker;
